<template>
  <v-row >
    <TreeMenu :dataSchedule="parameters" />
    <Segment v-if="showSegmentWindow" class="ml-3" />
    <Elements v-if="showElementWindow" class="ml-3" />
    <DFIS v-if="showDfisWindow" class="ml-3" />
    <Permission
      v-if="showScheduleWindow && selectedItemId !== null"
      :itemId="selectedItemId"
      class="ml-3"
    />
    <schedule-assistant v-if="showAssistentWindow" />
    <Holidays v-if="showHolidayWindow" class="ml-3" />
    <Groups v-if="showGroupWindow" class="ml-3" />
    <Employees v-if="showEmployeeWindow" class="ml-3" />
    <v-dialog
      v-model="openSchedule"
      max-width="400px"
      persistent
      @keydown.esc="reset(false)"
      class="yellow"
    >    
      <FormOrder
        :allFields="parameters.items"
        @save="saveForm"
        @cancel="reset"
        :mode="mode"
        :maxWidth="maxWidth"
         @itemUpdate="updateDataSelect"
      />
    </v-dialog>
    <DeleteDialog
      :showDialog="openDelete"
      :title="titleDelete"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
    />
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Employees from "./Employees.vue";
import Groups from "./Groups.vue";
import Holidays from "./Holidays.vue";
import TreeMenu from "./TreeMenu.vue";
import schedules from "@/store/permisosDeAcceso/accessPermissions.js";
import Form from "@/components/Complement/Form.vue";
import FormOrder from "@/components/Complement/FormOrder.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Loader from "@/components/Complement/Loader.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Permission from "./Permission.vue";
import SegmentsChildrens from "./SegmentsChildrens.vue";
import Segment from "./Segment.vue";
import ScheduleAssistant from "./ScheduleAssistant.vue";
import DFIS from './DFis.vue';
import Elements from './Elements.vue'
export default {
  components: {
    Employees,
    Groups,
    Holidays,
    ScheduleAssistant,
    Snackbar,
    Loader,
    TreeMenu,
    Form,
    DeleteDialog,
    Segment,
    SegmentsChildrens,
    Permission,
    FormOrder,
    DFIS,
    Elements
  },

  data() {
    return {
      title: this.$tc("schedules.schedule"),
      isLoading: true,
      color: "",
      alert: false,
      textAlert: "",
      titleDelete: this.$tc("accessPermision.toPermission"),
      dataChekboxes: [
        {
          name: "reqCacheo",
          label: this.$tc("accessPermision.requiredCacheo"),
          data: false,
        },
        {
          name: "reqPin",
          label: this.$tc("accessPermision.requiredPin"),
          data: false,
        },

        {
          name: "reqPassBack",
          label: this.$tc("accessPermision.requiredPassBack"),
          data: false,
        },
        {
          name: "visit",
          label: this.$tc("accessPermision.visit"),
          data: false,
        },
        {
          name: "active",
          label: this.$tc("accessPermision.active"),
          data: true,
        },
      ],

      dataSchedule: [
        {
          name: "name",
          label: this.$tc("accessPermision.namePermission"),
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) => v.length <= 50 || this.$tc("schedules.rulesDataSchedules"),
          ],
        },

        {
          name: "porcenCacheo",
          label: this.$tc("accessPermision.porcentCacheo"),
          data: 0,
          type: "number",
          rules: [
            (v) => v >= 0 || this.$tc("editRegistrations.requerid"),
            (v) => v <= 100 || this.$tc("schedules.rulesDataSchedules"),
          ],
        },
      ],

      maxWidth: "400px",
      showCard: true,
      itemToDelete: null,
      itemId: null,
      filteredSchedules: [],
    };
  },
  mounted() {
    schedules.dispatch("getPermissions").then(() => {
      this.isLoading = false;
    });
    schedules.dispatch("handleShowWindow", "assistent");
  },

  computed: {
      parameters() {
        return {
          items: [
            {
              id: 1,
              show: true,
              data: "",
              name: "name",
              type: "text",
              label: this.$tc("accessPermision.namePermission"),
              items: [],
              itemText: "name",
              itemText: "name",
              rules: [
                (v) =>
                  (v !== null && v !== undefined && v !== "") ||
                  this.$tc("editRegistrations.requerid"),
              ],
              order: 1,
            },
            {
              id: 2,
              show: true,
              data: false,
              name: "reqCacheo",
              type: "check",
              label: this.$tc("accessPermision.requiredCacheo"),
              order: 2,
            },
            {
              id: 3,
              show: true,
              disabled: true,
              data: "",
              name: "porcenCacheo",
              type: "text",
              label: this.$tc("accessPermision.porcentCacheo"),
              items: [],
              itemText: "name",
              itemText: "name",
              rules: [
               
              ],
              order: 3,
            },
            {
              id: 4,
              show: true,
              data: false,
              name: "reqPin",
              type: "check",
              label: this.$tc("accessPermision.requiredPin"),
              order: 4,
            },
            {
              id: 5,
              show: true,
              data: false,
              name: "reqPassBack",
              type: "check",
              label: this.$tc("accessPermision.requiredPassBack"),
              order: 5,
            },
            {
              id: 6,
              show: true,
              data: false,
              name: "visit",
              type: "check",
              label: this.$tc("accessPermision.visit"),
              order: 6,
            },
            {
              id: 7,
              show: true,
              data: true,
              name: "active",
              type: "check",
              label: this.$tc("accessPermision.active"),
              order: 7,
            },
          ],
        };
      },

      reqCacheo() {
      return this.parameters?.items?.find(item => item.name === 'reqCacheo').data;
    },
      
      scheduleAll() {
        return this.filteredSchedules.length > 0
          ? this.filteredSchedules
          : schedules.state.schedules;
      },
      schedules() {
        return schedules.state.permissions;
      },
      padding() {
        return schedules.state.paddingNav;
      },
      mode: {
        get() {
          return schedules.state.mode;
        },
        set(newValue) {
          return newValue;
        },
      },
      openSchedule: {
        get() {
          return schedules.state.openSchedule.value;
        },
        set(newvalue) {
          return newvalue;
        },
      },
      openDelete: {
        get() {
          return schedules.state.openDeletePermission;
        },
        set(newvalue) {
          return newvalue;
        },
      },
      selectedItemId() {
        return schedules.state.permissionId;
      },
      showScheduleWindow() {
        return schedules.state.showScheduleWindow;
      },
      showElementWindow() {
        return schedules.state.showElementWindow;
      },
      showDfisWindow(){
        return schedules.state.showDfisWindow;
      },
      showSegmentWindow() {
        return schedules.state.showSegmentWindow;
      },
      showAssistentWindow() {
        return schedules.state.showAssistentWindow;
      },
      showGroupWindow() {
        return schedules.state.showGroupsWindow;
      },
      showHolidayWindow() {
        return schedules.state.showHolidaysWindow;
      },
      showEmployeeWindow() {
        return schedules.state.showEmployeesWindow;
      },
    },
  
  watch: {
    allFields: {
      immediate: true,
      handler(value) {
        this.items = value;
      },
    },
  },

  methods: {

    updateDataSelect(item) {
      if(item.name ==="reqCacheo" && item.data== true){
       this.parameters.items.find(item => item.name ==="porcenCacheo").disabled =false
      }else if(item.name ==="reqCacheo" && item.data== true){
         this.parameters.items.find(item => item.name ==="porcenCacheo").disabled =true
      }
    },
    saveForm(items) {
      const type = schedules.state.openSchedule;
      switch (type.type) {
        case "add":
          this.addSchedule(items);
          break;
        case "edit":
          const payload = {
            id: schedules.state.editPermission,
            ...items,
          };
        
          this.editSchedule(payload);
          break;
        default:
          break;
      }
    },

    reset(value) {
      schedules.commit("setOpenSchedule", value);
      schedules.commit("setOpenElement", value);
      this.parameters.items.forEach((item) => {
      if (item.id === 7) {
        item.data = true;
      } else {
        item.data = "";
      }
      });

    },

    deleteItem() {
      schedules
        .dispatch("deletePermission")
        .then(() => {
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("accessPermision.deletePermissionAlert");
        })
        .catch((e) => {
          this.alert = true;
          this.color = "#FF8D58";
          this.textAlert = e.response.data.error.message;
        });
      this.resetDelete();
    },
    resetDelete() {
      this.openDelete = false;
      schedules.commit("setOpenDeletePermission", false);
      this.alert = false;
    },
    cancelDelete() {
      this.openDelete = false;
      schedules.commit("setOpenDeletePermission", false);
    },
    addSchedule(items) {
      schedules.commit("setNewPermission", items);
      schedules
        .dispatch("newPermission")
        .then(() => {
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("accessPermision.addPermissionAlert");
        })
        .catch((e) => {
          this.alert = true;
          this.color = "#FF8D58";
          this.textAlert = e.response.data.error.message;
        }); 
      this.reset(false);
    },
    editSchedule(item) {
      schedules.commit("setEditItemPermission", item);
      schedules
        .dispatch("editPermission")
        .then(() => {
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("accessPermision.editPermissionAlert");
        })
        .catch((e) => {
          this.alert = true;
          this.color = "#FF8D58";
          this.textAlert = e.response.data.error.message;
        }); 
      this.reset(false);
    },
  },
};
</script>
<style scoped>
.card_container {
  min-height: 450px;
}

.no-search {
  text-align: center !important;
  height: 300px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (min-width: 1000px) and (max-width: 1400px) {
  .card_container {
    max-height: 450px !important;
    overflow-y: scroll !important;
    overflow-x: hidden;
  }
}

@media (min-width: 1400px) and (max-width: 1800px) {
  .card_container {
    max-height: 750px !important;
    overflow-y: scroll !important;
    overflow-x: hidden;
    padding-bottom: 10px !important;
  }
}
</style>
